<template>
  <Layout>
    <div class="row masonry-container">
      <overview @clicked="onClickChild" class="item masonry-grid-item" id="overview"></overview>
      <marketing @clicked="onClickChild" class="item masonry-grid-item" id="marketing"></marketing>
      <tutorials
        v-if="isStylistNew"
        @clicked="onClickChild"
        class="item masonry-grid-item"
        id="tutorial"></tutorials>
      <register id="addClient" class="item masonry-grid-item"></register>
      <commissions @commissionsUpdated="updatedCommissions" id="commissions" class="item masonry-grid-item"></commissions>
      <commission-chart v-if="commissionData.length" :commissionData="commissionData" class="item masonry-grid-item"></commission-chart>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/router/layouts/main'
import Register from '@/components/register'
import Tutorials from '@/components/tutorials'
import Commissions from '@/components/commissions'
import Overview from '@/components/overview'
import Marketing from '@/components/marketing'
import CommissionChart from '@/components/commission-chart'
import Masonry from 'masonry-layout'
export default {
  data () {
    return {
      commissionData: []
    }
  },
  components: {
    CommissionChart, Marketing, Overview, Layout, Register, Tutorials, Commissions
  },
  created () {
    this.$store.dispatch('getIl8nContent')
  },
  methods: {
    onClickChild () {
      setTimeout(() => {
        const msnry = this.msnryGrid()
        msnry.destroy()
        setTimeout(() => {
          this.msnryGrid()
        })
      }, 1000)
    },
    msnryGrid () {
      const grid = document.querySelector('.masonry-container')
      const msnry = new Masonry(grid, {
        // options...
        itemSelector: '.masonry-grid-item',
        percentPosition: true
      })
      return msnry
    },
    updatedCommissions (commissionData) {
      this.commissionData = commissionData
    }
  },
  computed: {
    isStylistNew () {
      const stylist = this.$store.state.stylist
      if (!stylist || !stylist.created_at) return false
      const createdAt = new Date(stylist.created_at)
      const twoMonthsAgo = new Date()
      twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2)
      return createdAt > twoMonthsAgo
    }
  }
}
</script>
